import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-full bg-zinc-900" }
const _hoisted_2 = { class: "h-full" }
const _hoisted_3 = { class: "min-h-screen m-auto max-w-3xl flex flex-col justify-center items-center" }

import { onMounted } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'FormLayout',
  setup(__props) {

onMounted(() => {
  const body = document.getElementById("body");

  body?.classList.add("bg-zinc-900");
  body?.classList.remove("bg-white");
});

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_RouterView)
      ])
    ])
  ]))
}
}

})